import React from 'react'

/** @description Este componente se utiliza cuando un endpoint responde un arreglo vacio para avisarla al usuario que no hay datos disponibles en la vista  */
export const NoData = () => {
  return (
    <div className>No hay registros disponibles</div>
  )
}
